var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { config } from '../../../../../config/config';
import { CreateWholeTripCommand } from '../../../../commands/visitor/create.trip.command';
import { SocialLoginPopupComponent } from '../../../../common/components/social.login.popup/social.login.popup.component';
import { LocalStorageService } from '../../../../services/localStorageService';
import { ShareService } from '../../../../services/share.service';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { guid } from '../../../../utils/guid';
import { BaseComponent } from '../../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { HubAnalytics } from '../trip.side.bar/visitor.trip.side.bar.component';
import { ShareTripModalActions, ShareTripModalData } from './share.trip.modal.provider';
import { GlobalEventEmitter } from "../../../../common/services/global.event.emitter";
var ShareTripModalComponent = /** @class */ (function (_super) {
    __extends(ShareTripModalComponent, _super);
    function ShareTripModalComponent(dialogRef, activatedRoute, actions, formBuilder, visitorApiService, data) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.dialogRef = dialogRef;
        _this.activatedRoute = activatedRoute;
        _this.actions = actions;
        _this.formBuilder = formBuilder;
        _this.visitorApiService = visitorApiService;
        _this.help = {
            hubName: '',
            name: '',
            number: '',
            email: '',
            comment: '',
            inquiryEmail: ''
        };
        _this.shareToEmails = '';
        _this.data = Object.assign({}, data);
        _this.helpFormGroup = _this.formBuilder.group({
            'name': [null, [Validators.required]],
            'number': [null],
            'email': new FormControl('', Validators.compose([
                Validators.required,
                Validators.pattern(config.emailPattern)
            ])),
            'comment': [null, [Validators.required]],
        });
        _this.emailFormGroup = _this.formBuilder.group({
            'shareToEmails': new FormControl('', Validators.compose([
                Validators.required,
                Validators.pattern(config.emailPattern)
            ])),
        });
        setTimeout(function () {
            var googleSigninBtn = document.getElementById("google-signin-btn-trip");
            google['accounts'].id.renderButton(googleSigninBtn, { theme: "outline", size: "large" });
            googleSigninBtn.onclick = function () {
                _this.close();
            };
            GlobalEventEmitter.on('onGoogleLoginStatusChanged', function () {
                console.log('onGoogleLoginStatusChanged received');
                document.querySelector('body').click(); // make sure it it closed
                _this.close();
            });
        });
        return _this;
    }
    Object.defineProperty(ShareTripModalComponent.prototype, "shareTitle", {
        get: function () {
            if (this.data.type === 'trip') {
                if (this.data.isWholeTrip) {
                    return 'MY TRIPS';
                }
                else {
                    return 'THE TRIP: ' + this.data.title;
                }
            }
            else if (this.data.type === 'tour') {
                return 'THE ITINERARY';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShareTripModalComponent.prototype, "isUserLoggedIn", {
        get: function () {
            return SocialLoginPopupComponent.isUserLoggedIn;
        },
        enumerable: true,
        configurable: true
    });
    ShareTripModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    };
    ShareTripModalComponent.prototype.FBLoggedIn = function ($event) {
        if (this.actions.confirm) {
            this.actions.confirm($event, 'fb');
        }
        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    };
    ShareTripModalComponent.prototype.GoogleLogin = function ($event) {
        if (this.actions.confirm) {
            this.actions.confirm($event, 'google');
        }
        GlobalEventEmitter.off('onGoogleLoginStatusChanged');
        this.dialogRef.close();
    };
    ShareTripModalComponent.prototype.sendHelp = function (event) {
        var _this = this;
        this.help.hubName = this.data.hubName;
        this.visitorApiService.sendHelp(this.help).finally(event.complete).subscribe(function (data) {
            _this.sendHelpSuccess.success();
        });
    };
    ShareTripModalComponent.prototype.sendShareEmails = function (event) {
        var _this = this;
        if (!this.shareToEmails) {
            return;
        }
        if (this.data.type === 'trip') {
            var tripId = this.allRouteParams.tripId;
            if (tripId || this.data.wholeTripId) {
                this.visitorApiService.sendEmails(this.shareToEmails, ShareService.getTripLink(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId), this.data.hubName)
                    .finally(event.complete)
                    .subscribe(function (data) {
                    _this.sendEmailsSuccess.success();
                });
            }
            else {
                this.getTripIDAndShare('send-emails', event);
            }
            this.addShareUserTripCount();
        }
        else if (this.data.type === 'tour') {
            var tourId = this.allRouteParams.tourId;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            this.visitorApiService.sendEmails(this.shareToEmails, ShareService.getTourLink(this.data.hubName, tourId), this.data.hubName).finally(event.complete).subscribe(function (data) {
                _this.sendEmailsSuccess.success();
            });
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    };
    ShareTripModalComponent.prototype.shareByEmailApp = function () {
        if (this.data.type === 'trip') {
            var tripId = this.allRouteParams.tripId;
            if (tripId || this.data.wholeTripId) {
                window.location.href = ShareService.toMailableTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            }
            else {
                this.getTripIDAndShare('email');
            }
            this.addShareUserTripCount();
        }
        else if (this.data.type === 'tour') {
            var tourId = this.allRouteParams.tourId;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            window.location.href = ShareService.toMailableTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    };
    ShareTripModalComponent.prototype.shareTweet = function () {
        if (this.data.type === 'trip') {
            var tripId = this.allRouteParams.tripId;
            if (tripId || this.data.wholeTripId) {
                ShareService.tweetTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            }
            else {
                this.getTripIDAndShare('tweet');
            }
            this.addShareUserTripCount();
        }
        else if (this.data.type === 'tour') {
            var tourId = this.allRouteParams.tourId;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            ShareService.tweetTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    };
    ShareTripModalComponent.prototype.shareFacebook = function () {
        if (this.data.type === 'trip') {
            var tripId = this.allRouteParams.tripId;
            if (tripId || this.data.wholeTripId) {
                ShareService.facebookShareTrip(this.data.hubName, tripId || this.data.wholeTripId, this.data.singleTripId);
            }
            else {
                this.getTripIDAndShare('facebook');
            }
            this.addShareUserTripCount();
        }
        else if (this.data.type === 'tour') {
            var tourId = this.allRouteParams.tourId;
            if (!tourId) {
                tourId = this.data.wholeTripId;
            }
            ShareService.facebookShareTour(this.data.hubName, tourId);
            if (config.isAnalyticsOn) {
                this.visitorApiService.addShareCount(this.data.hubName, tourId).subscribe();
            }
        }
    };
    ShareTripModalComponent.prototype.addShareUserTripCount = function () {
        var analytics = new HubAnalytics();
        analytics.tripPlanner.shareClickCount = 1;
        if (config.isAnalyticsOn) {
            this.visitorApiService.updateTripPlanerAnalytics(this.data.hubName, analytics).subscribe();
        }
    };
    ShareTripModalComponent.prototype.getTripIDAndShare = function (shareBy, event) {
        var _this = this;
        var userID = SocialLoginPopupComponent.userId;
        //let {hubName} = this.allRouteParams;
        this.visitorApiService.getUserTrips(this.data.hubName, userID).subscribe(function (trip) {
            if (!trip || !trip.id) {
                var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(_this.data.hubName);
                var storage = localStorage.getItem(key);
                var tripsInCookie = JSON.parse(storage);
                var command_1 = new CreateWholeTripCommand();
                command_1.id = guid();
                command_1.userFacebookId = userID;
                command_1.hubName = _this.data.hubName;
                command_1.trips = tripsInCookie.trips;
                _this.visitorApiService.syncTripsToDB(_this.data.hubName, command_1).subscribe(function () {
                    _this.data.wholeTripId = command_1.id;
                    if (!_this.data.isWholeTrip && command_1.trips.length > _this.data.singleTripIndex) {
                        _this.data.singleTripId = command_1.trips[_this.data.singleTripIndex].id;
                    }
                    _this.shareByType(shareBy, event);
                });
            }
            else {
                _this.data.wholeTripId = trip.id;
                if (!_this.data.isWholeTrip && trip.trips.length > _this.data.singleTripIndex) {
                    _this.data.singleTripId = trip.trips[_this.data.singleTripIndex].id;
                }
                _this.shareByType(shareBy, event);
            }
        });
    };
    ShareTripModalComponent.prototype.shareByType = function (shareBy, event) {
        var _this = this;
        if (shareBy === 'email') {
            window.location.href = ShareService.toMailableTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        }
        else if (shareBy === 'facebook') {
            ShareService.facebookShareTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        }
        else if (shareBy === 'tweet') {
            ShareService.tweetTrip(this.data.hubName, this.data.wholeTripId, this.data.singleTripId);
        }
        else if (shareBy === 'send-emails') {
            this.visitorApiService.sendEmails(this.shareToEmails, ShareService.getTripLink(this.data.hubName, this.data.wholeTripId, this.data.singleTripId), this.data.hubName)
                .finally(event && event.complete)
                .subscribe(function (data) {
                _this.sendEmailsSuccess.success();
            });
        }
    };
    return ShareTripModalComponent;
}(BaseComponent));
export { ShareTripModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/share.trip.modal/share.trip.modal.component.ts.pre-build-optimizer.js